// extracted by mini-css-extract-plugin
module.exports = {"header":"NavBar_header__2ajj7","nav":"NavBar_nav__EhXKX","gif":"NavBar_gif__3HcRQ","add":"NavBar_add__c_nFE","toggle":"NavBar_toggle__1Gl2e","logo":"NavBar_logo__1wBSX"};